export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discussion de notre communauté"])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Echanger avec d'autres randonneurs"])}
}